import * as types from './userTypes';

export const initialState = {
	authorizing: true,
	authorized: false,
	email: null,
	role: null,
	roleFeatures: null,
	projectUserGroups: []
};

export default function userReducer(state = initialState, action) {
	switch (action.type) {
		case types.USER_AUTHORIZE: {
			return {
				...state,
				authorized: action.payload.authorized,
				email: action.payload.email,
				role: action.payload.role,
				roleFeatures: action.payload.roleFeatures,
				projectUserGroups: action.payload.projectUserGroups,
				authorizing: false
			};
		}
		default:
			return state;
	}
};

